import { symbolOf, tradeValue, isValidSet } from '../selectors';
import type { PlayerId, TerritoryId } from '../types';
import type { Ctx } from './context';
import { RuleError } from './context';

export function drawTerritoryCard(ctx: Ctx, p: PlayerId): void {
  const { s, rng } = ctx;
  if (s.deck.length === 0 && s.discard.length > 0) {
    s.deck = rng.shuffle(s.discard);
    s.discard = [];
  }
  const card = s.deck.shift() ?? null;
  if (card) s.players[p].cards.push(card);
  ctx.events.push({ type: 'cardDrawn', player: p, card });
}

export function tradeCards(ctx: Ctx, p: PlayerId, cards: TerritoryId[]): number {
  const { s } = ctx;
  if (!isValidSet(cards.map((c) => symbolOf(s, c)))) throw new RuleError('invalid_set');
  const hand = s.players[p].cards;
  for (const c of cards) hand.splice(hand.indexOf(c), 1);
  s.discard.push(...cards);
  const troops = tradeValue(s.info.ruleset, s.tradeCount);
  s.tradeCount++;
  s.reinforcements += troops;
  ctx.events.push({ type: 'trade', player: p, cards: [...cards], troops });
  return troops;
}
